import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { components } from 'react-select';

const CompactControlComponent = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const { selectProps } = props;
    return (jsx(components.Control, Object.assign({}, props, { className: [
            className,
            "select-control",
            selectProps.isSearchable ? "select-control--searchable" : null,
        ]
            .filter(Boolean)
            .join(" ") }, { children: children })));
};

export { CompactControlComponent };
//# sourceMappingURL=RCompactSelectDerived.js.map
